<template>
	<div class="Page-Casino">
    <swiper class="swiper" :options="swiperOptions">
      <swiper-slide>
        <div class="slide" style="width: 100%; height: 330px; background: url('/static/assets/img/casino/202dc76d-banner_desktop-1.jpeg') center;
backgorund-size: cover; background-repeat: no-repeat; background-position: center;">
          s
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide" style="width: 100%; height: 330px;
        background: url('/static/assets/img/casino/ecf789c4-welcomenew_lar.jpeg') center;
        backgorund-size: cover; background-repeat: no-repeat; background-position: center;">
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="slide" style="width: 100%; height: 330px;
        background: url('/static/assets/img/casino/91713537-15tridents_desktop.jpeg') center;
        backgorund-size: cover; background-repeat: no-repeat; background-position: center;">
        </div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>

    <carousel v-on:result="getSearchGameList" v-on:provider="fetchVendor" :live="false" />


    <resultList :list="searchResult" />

		<div class="row">
			<div class="col-12" v-if="$route.meta.isLive">

			</div>
		</div>

    <!-- <highlightedGames /> --->

		<template>

      <popularGames :category="[113]" v-if="!$route.query.provider" />

      <providerGames :provider="vendor" v-if="!$route.query.category && !$route.query.provider" v-for="vendor in vendors"></providerGames>

      <div class="" v-if="$route.query.category || $route.query.provider">
        <section class="CasinoGames GamesList GamesListGrid MsnRow">
          <h2 class="BoxTitle GamesContainerTitle"><a class="ComponentAnchor GameCategory Anchor Anchor " href="javascript:;" title="Game List" id="CategoryGameList-Nur-bei-uns">Game List</a></h2>
          <div class="GamesSwipeable">
            <div class="GamesWrapper">
              <ul class="GamesListContainer HorizontalScrollBar HasLoadMoreButton List ListUnordered">
                <li class="ListGame ListItem GameTileContainer MasonryTile-1x1" v-if="games" v-for="game in games">
                  <a class="ComponentAnchor GamePlayNowButton Anchor " href="javascript:;" v-on:click="openGame(game)" :title="game.name">
                  <span class="SvgIcon PlayButton">
                     <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
                        <path fill="#fff" d="M37.862 28.75l-15.32 9.913A.999.999 0 0121 37.824V18a1 1 0 011.543-.84l15.32 9.912a1.002 1.002 0 01-.001 1.679z"></path>
                        <path fill="#fff" d="M28 54c14.36 0 26-11.64 26-26S42.36 2 28 2 2 13.64 2 28s11.64 26 26 26zm0 2C12.536 56 0 43.464 0 28S12.536 0 28 0s28 12.536 28 28-12.536 28-28 28z"></path>
                     </svg>
                  </span>
                  </a>
                  <img class="GameThumb ListGameImage LazyImage" :alt="game.name" onerror="this.onerror=null;this.src = this.src.replace('.gif', '.jpg')" :src="game.thumbnail">
                  <div class="GameProp GameVendor SubVendor" itemprop="author">{{ game.vendor.name }}</div>
                  <div class="GameProp NewGame">NEU</div>
                  <div class="GameTitle">{{ game.name | slimiter(20) }}</div>
                </li>
              </ul>
              <div v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"></div>
            </div>
          </div>

          <VueContentLoading
              v-if="busy"
              viewBox="0 0 1300 900" :height='900' :width='1300'
              :speed="1"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
          >
            <rect x="30" y="20" rx="8" ry="8" width="200" height="200" />
            <rect x="30" y="250" rx="0" ry="0" width="200" height="18" />
            <rect x="30" y="275" rx="0" ry="0" width="120" height="20" />
            <rect x="250" y="20" rx="8" ry="8" width="200" height="200" />
            <rect x="250" y="250" rx="0" ry="0" width="200" height="18" />
            <rect x="250" y="275" rx="0" ry="0" width="120" height="20" />
            <rect x="470" y="20" rx="8" ry="8" width="200" height="200" />
            <rect x="470" y="250" rx="0" ry="0" width="200" height="18" />
            <rect x="470" y="275" rx="0" ry="0" width="120" height="20" />
            <rect x="690" y="20" rx="8" ry="8" width="200" height="200" />
            <rect x="690" y="250" rx="0" ry="0" width="200" height="18" />
            <rect x="690" y="275" rx="0" ry="0" width="120" height="20" />
            <rect x="910" y="20" rx="8" ry="8" width="200" height="200" />
            <rect x="910" y="250" rx="0" ry="0" width="200" height="18" />
            <rect x="910" y="275" rx="0" ry="0" width="120" height="20" />
            <rect x="1130" y="20" rx="8" ry="8" width="200" height="200" />
            <rect x="1130" y="250" rx="0" ry="0" width="200" height="18" />
            <rect x="1130" y="275" rx="0" ry="0" width="120" height="20" />
            <rect x="30" y="340" rx="8" ry="8" width="200" height="200" />
            <rect x="30" y="570" rx="0" ry="0" width="200" height="18" />
            <rect x="30" y="595" rx="0" ry="0" width="120" height="20" />
            <rect x="250" y="340" rx="8" ry="8" width="200" height="200" />
            <rect x="250" y="570" rx="0" ry="0" width="200" height="18" />
            <rect x="250" y="595" rx="0" ry="0" width="120" height="20" />
            <rect x="470" y="340" rx="8" ry="8" width="200" height="200" />
            <rect x="470" y="570" rx="0" ry="0" width="200" height="18" />
            <rect x="470" y="595" rx="0" ry="0" width="120" height="20" />
            <rect x="690" y="340" rx="8" ry="8" width="200" height="200" />
            <rect x="690" y="570" rx="0" ry="0" width="200" height="18" />
            <rect x="690" y="595" rx="0" ry="0" width="120" height="20" />
            <rect x="910" y="340" rx="8" ry="8" width="200" height="200" />
            <rect x="910" y="570" rx="0" ry="0" width="200" height="18" />
            <rect x="910" y="595" rx="0" ry="0" width="120" height="20" />
            <rect x="1130" y="340" rx="8" ry="8" width="200" height="200" />
            <rect x="1130" y="570" rx="0" ry="0" width="200" height="18" />
            <rect x="1130" y="595" rx="0" ry="0" width="120" height="20" />
          </VueContentLoading>
        </section>
      </div>


				<sweet-modal ref="umodal" v-on:close="closeModal" width="100%" height="100%" modal-theme="dark" overlay-theme="dark">
					<iframe id="iframeGame"
					        v-if="iframeUrl"
					        :src="iframeUrl"
                  allowfullscreen="true"
					        scrolling="auto" frameborder="0">
					</iframe>

					<div v-if="html" id="iframe-content"></div>
				</sweet-modal>
			</template>

	</div>
</template>

<script>
      import resultList from "./widget/resultList";
      import providerGames from "./widget/providerGames";
      import categoryList from "@/components/casino/widget/categoryList";
      import VueContentLoading from 'vue-content-loading';
    	import gameSearch from "@/components/casino/widget/gameSearch";
    	import spinalLoader from '@/components/ui/loader/spinalLoader.vue'
      import highlightedGames from "./widget/highlightedGames";
    	import carousel from "../ui/carousel";
    	import popularGames from "./widget/popularGames";

    export default {
        name: 'casino',
	      components: { popularGames, carousel, resultList, highlightedGames, providerGames, categoryList, VueContentLoading, spinalLoader, gameSearch },
        props: {
              isLive: {

              }
        },
        data () {
            return {
                searchResult: null,
                render: 0,
                t: this.$root.t,
                bsapi: bsapi,
                games: null,
                session:  this.$root.session,
                sessid: null,
                cstoken: null,
                page: 1,
                gameId: null,
                iframeUrl: null,
                busy: false,
                html: null,
                eventNotfound: false,
                intersectionOptions: {
                  root: null,
                  rootMargin: '0px 0px 0px 0px',
                  threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
                },
	              liveVendors: [
                  {name: 'Xpro Gaming', s: 'xpg'},
                  {name: 'Ezugi', s: 'ezugi'},
                  {name: 'Bet games', s: 'betgames'},
                  {name: 'Luckystreak', s: 'luckystreak'},
                ],
                vendors: [
                    {name: 'NETENT', s: 'netent'},
                    {name: 'Egt', s: 'egt'},
                    {name: 'Aristocrat', s: 'aristocrat'},
                    {name: 'Novamatic', s: 'novomatic'},
                    {name: 'Micro Gaming', s: 'microgaming'},
                    {name: 'Amatic', s: 'amatic'},
                    {name: 'Wazdan', s: 'wazdan'},
                    {name: 'Roulette', s: 'roulette'},
                    {name: 'Table Games', s: 'table_games'},
                    {name: 'Keno', s: 'keno'},
                    {name: 'New', s: 'disable'},
                ],
                swiperOptions: {
                  effect: 'slide',
                  autoplay: {
                    delay: 5000
                  },
                  slidesPerView: 1,
                  spaceBetween: 0,
                  // init: false,
                  navigation: {
                    nextEl: '.EventCards-styles-arrow-container-right',
                    prevEl: '.EventCards-styles-arrow-container-left'
                  },
                  pagination: {
                    el: '.swiper-pagination'
                  },
                  // Some Swiper option/callback...
                }
            }
        },
        watch: {
          '$route.query.provider' () {

            //window.location.reload()
            this.busy = false
            this.eventNotfound = false;
            this.games = null;
            this.page = 1;
            this.fetchGames()

          },
	        '$route.query.category' () {

                this.games = null;
	              this.page = 1;
                this.busy = false;
                this.eventNotfound = false;

                this.fetchGames()

                if(this.$route.params.game){
                    this.openGame({vendor: this.$route.provider, extended_id: this.$route.params.game});
                }
	        },
          '$route.params.game' (v) {

	          if(v > 0)
              this.openGame({vendor: this.$route.provider, extended_id: this.$route.params.game});
          }
      },
      beforeDestroy() {
            var el = document.getElementById('casinoCSS');
            el.remove();
      },
	    mounted () {

            var cssId = 'casinoCSS';  // you could encode the css path itself to generate id..
            if (!document.getElementById(cssId))
            {
              var head  = document.getElementsByTagName('head')[0];
              var link  = document.createElement('link');
              link.id   = cssId;
              link.rel  = 'stylesheet';
              link.type = 'text/css';
              link.href = 'static/assets/css/casino.css';
              link.media = 'all';
              head.appendChild(link);
            }

            //this.scroll();
            //this.getCasinoAuth()
            this.fetchVendor();
            //this.getCasinoSession();
            setTimeout(this.fetchGames, 300);

            (function() {
              var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true;
              lc.src = ('https:' == document.location.protocol ? 'https://' : 'https://') + 'static-cdn.betsolutions.com/casino/GameStarter/Prod/gameStarter.min.js?v=18092019053918';
              var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
            })();
	    },
	    methods: {
            onWaypoint({el, going, direction}) {
              // going: in, out
              // direction: top, right, bottom, left
              if (going === this.$waypointMap.GOING_IN) {
                //console.log('waypoint going in!');

                this.fetchGames();
                //console.log(`#${el.getAttribute('m')}`)
              }

              if (going === this.$waypointMap.GOING_OUT) {
                //console.log(direction)
              }

              if (direction === this.$waypointMap.DIRECTION_TOP) {
                //console.log('waypoint going top!')
              }
            },
            getSearchGameList (v){
              this.searchResult = v;
            },
            getCasinoAuth (){
              this.$http.get(api + 'api/v1/ply-casino/auth')
                .then(response => {
                  this.cstoken = response.body.AuthCode;
                }, response => {

                })
            },
            closeModal () {
                this.$router.replace({params: {game: null}, query: this.$route.query})
                this.scroll();
                this.iframeUrl = null;
            },
            resetVariables () {
                this.page = 1;
                this.games = null;
                this.eventNotfound = false;
            },
            fetchVendor (v) {
              this.vendors = v
            },
            scroll () {
                window.onscroll = () => {
                    var bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.scrollHeight;
                    if (bottomOfWindow) {
                        this.page = (this.page + 1);
                        this.fetchGames();
                    }
                };
            },
            fetchGames () {

                if (!this.busy && !this.eventNotfound) {

                    this.busy = true;
                    this.$http.get(api+'api/v1/casino/games', {
                        params: {page: this.page, category: [this.$route.query.category], provider: [this.$route.query.provider], device: 'desktop', per_page: 60},

                    }).then(response => {

                    var th = this;
                        // get body data
                    if (!this.games) {
                        th.games = [];
                        response.body.result.forEach(function(item) {
                          th.games.push(item.game);
                        });
                    }else {
                        response.body.result.forEach(function(item) {
                            th.games.push(item.game);
                        });
                    }

                    this.pagination = response.body.pagination;
                    this.loader = false;
                    this.page = (this.page + 1);
                    setTimeout(() => {

                    const th = this;
                    th.busy = false;
                    const imgloaded = require('imagesloaded')
                    const elem = document.querySelector('.game-list')
                    var imgLoad = imgloaded( elem )
                    function onAlways() {

                        var msnry = new Masonry( '.xsax', {
                            itemSelector: '.gb',
                            isFitWidth : false,
                            transitionDuration : 0
                        });

                        // //console.log('all images are loaded')
                    }
                    if (elem) {
                        // bind with .on()
                        imgLoad.on( 'always', onAlways )
                        // unbind with .off()
                        // imgLoad.off( 'always', onAlways )
                    }

                }, 300)


                }, response => {
                        // error callback
                        this.eventNotfound = true;
                        this.loader = false;
                        this.busy = false;
                    })
                }

            },
		    openGame (game) {

                if (window.session.uid == 0) {
                    //swal(this.t.processing.error, this.t.auth.bet_auth, "error")
                    return false
                }

                this.iframeUrl = null;
                this.gameId = game.id;
                this.$refs.umodal.open();

                if(game.vendor === 'betsolutions') {

                  this.$http.get(api+'api/v1/betsolutions/playnow', {
                    params: {
                      provider: game.vendor,
                      gameId: game.extended_id,
                      productId: game.secondary_id,
                      platform: 'desktop',
                      token: this.cstoken
                    }
                  }).then(response => {
                    // get body data
                    var data = response.body;

                    this.iframeUrl = data.point;
                    //console.log(response.body.data);

                  }, response => {
                    // error callback
                    this.eventNotfound = true;
                    this.loader = false;
                  });

                }

                this.$http.get(api+'api/v1/casino/playnow', {
                    params: {
                        provider: game.vendor,
                        gameId: game.extended_id,
                        token: this.cstoken
                    }
                }).then(response => {
                    // get body data
	                var data = response.body;

	                if(data.content.game.iframe == 1){
	                    this.iframeUrl = data.content.game.url;
	                }

	                if(data.content.game.iframe == 0){
                        var re = new RegExp(/'token', '(.*)']/);


                        if (data.html_code.match(re)) {
                            // //console.log(data.html_code.match(re)[1]);

                            this.iframeUrl = 'https://game2.betgamestv.eu/ext/client/index/fundist/'+data.html_code.match(re)[1]+'/en/0/5/0/default?home_url=https%3A%2F%2Fbetgames.tv';
                        }
	                }

                    //console.log(response.body.data);

                }, response => {
                    // error callback
                    this.eventNotfound = true;
                    this.loader = false;
                })
		    }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.big-top {
		font-size: 120px;
		text-align: center;
	}
	.medium-top {
		font-size: 90px;
		text-align: center;
		position: absolute;
		left: 34%;
		top: 40%;
	}
	.small-bottom {
		font-size: 58px;
		text-align: center;
		position: absolute;
		left: 34%;
		top: 65%;
	}
	.casinoBanner {
		padding: 30px;
		width: 100%;
		height: 380px;
		position: relative;
		background: #fff;
		color: orangered;
	}
	.casinoBanner .confetti{
		background: url(../../../static/assets/img/rivalo/confetti.svg);
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
	}
	.slotPromo {
		position: absolute;
		top: 90px;
		left: 0;
		width: 390px;
		height: 205px;
		background: url(../../../static/assets/img/rivalo/slot_promo_1x.png);
		background-size: cover;
		z-index: 0;
	}
	.slotPromo2 {
		position: absolute;
		top: 40px;
		right: 0;
		width: 390px;
		height: 330px;
		background: url(../../../static/assets/img/rivalo/slot_promo_2.png);
		background-size: cover;
		z-index: 0;
	}
	.nav-link {
		color: #fff !important;
	}
	.page-head.Casino {
		color: #fff;
		background: #ccc;
	}
	.casino-area {
		max-width: 2040px;
		margin: auto;
	}
	.elc-tablo,.page-head {
		background: white !important;
	}
	#iframeGame {
		width: 100%;
		height: 48vw;
	}
	.game-list {
		width: 100%;
		padding: 0px 10px;
	}
	.game-list span {
		padding: 5px 3px;
		font-size: 11px;
	}
	.game-list img {
		width: 100%;
	}
  .el-tablo .provider{
    background: #37003c;
    padding: 4px;
    position: absolute;
    right: 8px;
    top: 5px;
    color: #fff;
    text-transform: uppercase;
  }
	a.el-tablo {
		min-height: 200px;
		background-color: #323c58;
		box-shadow: 0px 5px 15px rgba(22,22,35,0.1);
	}
	.el-tablo {
		position: relative;
	}
	.el-tablo .hover a{
		font-size: 16px;
		background: #f64835;
		padding: 15px;
		min-width: 140px;
		border-radius: 5px;
		color: #fff;
    	text-align: center;
    	display: block;
	}
  .el-tablo .hover a.register{
    background: green;
  }
	.el-tablo .hover {
    padding: 2px 10px;
		display: none;
		line-height: 100%;
		justify-content: center;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		position: absolute;
		align-items: center; /* Vertical center alignment */
		justify-content: center;
	}
	.el-tablo:hover .hover {
		display:flex;
		background: linear-gradient(to bottom, rgba(0,0,0,0.65) 0%,rgba(0,0,0,0.6) 100%) !important;
	}
  .nav-tabs {
    border: none;
  }

  .cover-image {
    width: 100%;
    height: 190px;
    background-size: cover;
  }

  .slide {
    width: 100vw;
  }

</style>



// WEBPACK FOOTER //
// src/components/casino/game.vue